import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor() { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = localStorage.getItem('token');
    const originaltoken = localStorage.getItem('originalToken');

    if (token) {
      if (request.url.includes('Company/departments')) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        request.headers.append('Content-Type', 'application/xml');
        request.headers.append('Access-Control-Allow-Origin', '*');
        return next.handle(request);
      }

      if ((request.url.includes('isAdmin') || request.url.includes('Company')) && !request.url.includes('GetByUser') && !request.url.includes('RecordsIRM') && !request.url.includes('RecordsDLP')) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${originaltoken}`
          }
        });
      } else {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
      request.headers.append('Content-Type', 'application/xml');
      request.headers.append('Access-Control-Allow-Origin', '*');
    }
    return next.handle(request);
  }
}
